import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { LoginData, setDataLogin } from '../store/slices/loginSlice';

export function useLogin() {
  const dispatch = useDispatch<AppDispatch>();
  const login = useSelector((state: RootState) => state.login);

  return {
    loginType: login.loginType,
    email: login.email,
    npub: login.npub,
    otpId: login.otpId,
    setDataLogin: useCallback((data: LoginData) => 
      dispatch(setDataLogin(data)), [dispatch]),
  };
} 